/**
 *
 * Asynchronously loads the component for SamplePlatesPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SamplePlatesPage = lazyLoad(
  () => import('./index'),
  module => module.SamplePlatesPage,
);
